import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { MAT_MENU_DEFAULT_OPTIONS, MatMenuDefaultOptions } from '@angular/material/menu';
import { ISupportedLanguage, LLanguage, LanguageService } from 'core/services';
import { DsgDeepTranslationKey } from 'projects/designer/src/app/pipes/translate.pipe';
import { BehaviorSubject, filter, map } from 'rxjs';
import { SidenavService } from '../../sidenav.service';



@Component({
  selector: 'ss-language-select',
  templateUrl: './language-select.component.html',
  styleUrls: ['./language-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    { provide: MAT_MENU_DEFAULT_OPTIONS, useValue: { overlayPanelClass: ['border-radius-small', 'box-shadow'] } as MatMenuDefaultOptions }
  ],
  encapsulation: ViewEncapsulation.None
})
export class LanguageSelectComponent {

  readonly supportedLanguages = this._languageService.supportedLanguages.map((lang) => lang as { key: LLanguage, display: DsgDeepTranslationKey });
  readonly selectedLanguageSubject = this._languageService.selectedLanguageSubject;
  readonly selectedItemObs = this.selectedLanguageSubject.pipe(
    filter(Boolean),
    map((selectedLanguage) => this.supportedLanguages.find(({ key }) => selectedLanguage === key))
  )

  readonly expandedSubject = new BehaviorSubject<boolean>(true)
  @Input() get expanded() {
    return this.expandedSubject.value
  }
  set expanded(value) {
    this.expandedSubject.next(value)
  }

  readonly collapsedObs = this._sidenavService.expandedSubject.pipe(map((expanded) => !expanded));

  readonly widthObs = this.collapsedObs.pipe(map((collapsed) => collapsed ? '100%' : '80%'))

  constructor(
    private readonly _languageService: LanguageService,
    private readonly _sidenavService: SidenavService
  ) {

  }


  selectLanguage(language: ISupportedLanguage) {

    this.selectedLanguageSubject.next(language.key)
  }

}
